module.exports = __webpack_public_path__ + "img/data-report.0494d78a.svg";